<script>
import {  mapGetters } from "vuex";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CreateSetup from '../customer/list/setup'
import Transaction from '../customer/list/transaction'
import TechDetay from '../customer/modals/tech_detail'
import Vue from 'vue';
import { notify } from '@/helpers/notify' 
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Datatable from '@/components/Datatable'

export default {
  page: {
    title: "Arıza Listesi",
  },
  mixins: [ datatableMixin ],
  components: {
    Layout,
    PageHeader,
    CreateSetup,
    Transaction,
    TechDetay,
    Datatable
  },
  computed: {
      ...mapGetters('authfack',['userdata'])
  },
  data() {
    return {
      title: "Arıza Listesi",
      items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "ARIZA LİSTESİ",
          active: true,
        },
      ], 

      searchParams: { il: '', bolge: ''},
        columns: [
            { name: '', key: 'action', orderable: false },
            { name: 'Kullanıcı Adı', key: 'username'},
            { name: 'İsim Soyisim', key: 'fullname', width: 150 },
            { name: 'Randevu Tarihi', key: 'appointment', className: 'text-end', orderable: true, width: 150  },
            { name: 'Cep Telefonu', key: 'phonenumber', className: 'text-end', width: 150  },
            { name: 'Whatsapp', key: 'phonenumber2', className: 'text-end', width: 150  },
            { name: 'İl', key: 'province', className: 'text-end', width: 150},
            { name: 'Bölge', key: 'township', className: 'text-end',  width: 150  },
            { name: 'Adres', key: 'address', className: 'text-end',  width: 150  },
            { name: 'Personel', key: 'user_name', className: 'text-end',  width: 150  },
            { name: 'Servis', key: 'tariff_name', className: 'text-end',  width: 350  },
        ],
        tableData: {
        detail: false,
        excel: true,
            searchable:{
                visible:true,
                placeholder:"İsim Soyisim Ara"
            }
        },
        endpoint: '/listeler/ariza-listesi',
        exportName: 'ARIZA_LISTESI',

        techDetail:{},
        assignData: {},
        modelOpen:0,
        buttons:[
          { title:"Randevu Ver", func:this.assign, visible: [1,2,3,4] },
          { title:"Arıza Detay", func:this.arizaDetay, visible: [3] },
          { title:"Tablodan Kaldır", func:this.sil, visible: [1,2,3,4] },
        ],  
        data:{},
        list: {},
        transactionData:{},
        bolgeList:[],
        ilList:[],
    };
  },
 
  methods: {
    async loadPage() {
          
          this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true
          
          const response = await  this.$http.post(this.endpoint, { params: this.params, search_params: this.searchParams, sort:this.sort, search_query: this.searchQuery });
          if (this.params.page === 1) {
              this.tableData.data = response.data.data;
          } else {
              this.tableData.data = [...this.tableData.data, ...response.data.data];
          }
      
          this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
          this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false
      },
          

    arizaDetay(props){
      this.techDetail = props
      this.$parent.$bvModal.show('tech_detail')
    },

    assign(props){
      this.modelOpen += 1
      this.assignData = { type:3, subs_id :props.subs_id, tech_id:props.id }
      this.$parent.$bvModal.show('setup')
    },
    
    sil(props){
      Vue.swal({
          title: "Silinecek?",
          showCancelButton: true,
          cancelButtonText: "İptal",
          confirmButtonText: "Sil"
      }).then((result) => {
          if (result.value) {
            this.$http.delete('/technic-service/ariza-sil/' + props.id)
            .then(response => {
                if(response.data.code == 100){
                  this.loadPage()
                  return notify.success(response.data.message)
                }
                return notify.error(response.data.message)
            })
          }
      });
    },

    popoverContent(histories) {
        const listItems = histories.map(history => {
          return `
            <li>${history.description}</li>
          `;
        }).join('');

        return `<ul>${listItems}</ul>`;
      },
      
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"  :items="items" />
    <CreateSetup  
      :data="modelOpen"
      :type="assignData.type" 
      :randevu="true"
      :subs_id="assignData.subs_id" 
      :tech_id="assignData.tech_id"
      @loadItems="loadPage" 
    />

    <Transaction 
      :transactionData="transactionData"  
      @loadItems="loadPage" 
    />

    <TechDetay 
      :data="techDetail" 
    />
    
    <div class="row"> 
      <div class="col-12">
        <Datatable 
              :columns="columns" 
              :tableData="tableData" 
              @sort-column="handleSortColumn"
              @search-query="reLoadPage"
              @excel-export="excelExport"
              :loading="isLoading"
              :poading="pageLoading">
          
             
          <!--<template #filter-province="{ row }">
                <select class="form-select form-select-sm" @change="loadPage()" v-model="searchParams.il">
                  <option value="">İl</option>
                  <option value="" v-for="(bolge,i) in ilList" :key="`il${i}`">1</option>
                </select>
          </template>-->

        
          <template #created_at="{ row }">
              {{ created_at(row) }}
          </template>
          
          <template #appointment="{ row }">
          
           <div v-if="row.postpone">
              <span v-if="row.hasOwnProperty('histories') && row.histories.length > 0"  v-b-popover.hover.auto.html="popoverContent(row.histories)">
                <span class='badge rounded-pill bg-warning font-size-12'>Ertelenmiş</span>
              </span>
            </div>
            <div v-else>
              {{ formatDate(row.appointment_at, 'DD.MM.YYYY HH') }}
            </div>
          </template>

          <template #address="{ row }">
            <span v-b-popover.hover.auto="row.address">{{ row.address }}</span>
          </template>

          <template #expiredate="{ row }">
              {{ expiredate(row.expiredate) }}
          </template>
          <template #phonenumber="{ row }">
              <a :href="`tel:${row.phonenumber}`"  >{{row.phonenumber}}</a>
          </template>
          <template #phonenumber2="{ row }">
                <a target="_blank" :href='`https://wa.me/${row.phonenumber2}`' >{{ row.phonenumber2}}</a>
          </template>
          
          <template #action="{ row }">
              <b-dropdown
                  toggle-class="font-size-16 p-0"
                  toggle-tag="a"
                  variant="white"
                  append-to-body
                  >
                  <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                  </template> 
                    <b-dropdown-item 
                    v-for="(button,i) in buttons"
                    :key="i" 
                    @click="button.func(row)">
                      {{ button.title }}
                  </b-dropdown-item>
              </b-dropdown>
          </template>
        </Datatable>
      </div>
    </div>
  </Layout>
</template>